module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "checkActive"
    }
  }, [_vm._v("Активность техцентра\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary mr-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabled),
      expression: "enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "checkActive",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enabled) ? _vm._i(_vm.enabled, null) > -1 : (_vm.enabled)
    },
    on: {
      "click": function($event) {
        _vm.$emit('input', !_vm.enabled)
      },
      "change": function($event) {
        var $$a = _vm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enabled = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.enabled) ? _c('small', [_vm._v("включен")]) : _c('small', [_vm._v("выключен")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e3ec391c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-e3ec391c"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcCheckBox.vue
// module id = 1077
// module chunks = 1